import React from "react";
import {cn} from "../utils";

const MoonIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="512"
        width="512"
        viewBox="0 0 24 24"
        className={cn(className)}
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="m14.4746 3 .2175-.71776c-.2647-.08025-.5522-.00821-.7478.18743-.1957.19564-.2677.4831-.1875.74788zm-11.4746 11.4746.21755-.7178c-.26478-.0802-.55224-.0082-.74788.1875-.19564.1956-.26768.4831-.18743.7478zm11.1187-8.80297c0 4.66517-3.7819 8.44707-8.44707 8.44707v1.5c5.49357 0 9.94707-4.4535 9.94707-9.94707zm6.1313 6.13137c0 4.6651-3.7819 8.447-8.447 8.447v1.5c5.4936 0 9.947-4.4534 9.947-9.947zm-5.9929-8.08524c3.469 1.05144 5.9929 4.27456 5.9929 8.08524h1.5c0-4.4898-2.974-8.28298-7.0579-9.52076zm-.5003-.50021c.2352.77571.3619 1.59942.3619 2.45408h1.5c0-1.00368-.1489-1.97393-.4263-2.88918zm-1.9538 17.03245c-3.81068 0-7.0338-2.5239-8.08524-5.9929l-1.43552.435c1.23778 4.0839 5.03096 7.0579 9.52076 7.0579zm-6.13137-6.1313c-.85466 0-1.67837-.1267-2.45408-.3619l-.4351 1.4356c.91525.2774 1.8855.4263 2.88918.4263z"
            fill={color || "currentColor"}/>
    </svg>
);

export {MoonIcon};